module.exports = __webpack_public_path__ + "static/media/BadExampleOptimized.8d1fe145.webp";